import React from "react";
import "react-select2-wrapper/css/select2.css";

import { Row, Col } from "react-bootstrap";
import StudentTargetSelector from "./StudentTargetSelector.js";
import UploadTargets from "./UploadTargets.js";
import AssignmentDetails from "./AssignmentDetails.js";
import ConfigEditor from "./ConfigEditor.js";
import RegradeRequests from "./RegradeRequests.js";

export default function StaffView({
  students,
  onSubmit,
  canEditConfig,
  canExportGrades,
}) {
  if (window.location.toString().includes("histogram")) {
    return <AssignmentDetails onLogin={onSubmit} />;
  }
  if (canEditConfig && window.location.toString().includes("edit")) {
    return <ConfigEditor />;
  }
  if (window.location.toString().includes("regrades")) {
    return <RegradeRequests />;
  }
  return (
    <div>
      <Row>
        <Col>
          <StudentTargetSelector
            students={students}
            onSubmit={onSubmit}
            canEditConfig={canEditConfig}
            canExportGrades={canExportGrades}
          />
        </Col>
      </Row>
      {canEditConfig ? <UploadTargets /> : <br />}
    </div>
  );
}
